/**
 * 논서술형 챕터 상세 조회 + 시작/제출 액션.
 * 학생 풀이 화면(EssayPlay) 진입 시 이 훅으로 시나리오·문항 트리 전체를 한 번에 받아온다.
 */
import api from "pages/api/axiosInstance";
import useSWR from "swr";
import {
  EssayChapterDetailResponse,
  ChapterStartResponse,
  ChapterSubmitResponse,
} from "./types";

interface BaseResponse<T> {
  isSuccess: boolean;
  code: number;
  message: string;
  result: T;
}

/** 챕터 상세 조회. `GET /app/essay-learning/chapters/{id}` */
export const useGetEssayChapter = (chapterId: number | null | undefined) => {
  return useSWR<EssayChapterDetailResponse | undefined>(
    chapterId ? [`/app/essay-learning/chapters/${chapterId}`, chapterId] : null,
    async ([url]: [string, number]) => {
      const res = await api.get<BaseResponse<EssayChapterDetailResponse>>(url);
      return res.data.result;
    }
  );
};

/** 챕터 시작. `POST /app/essay-learning/chapters/{id}/start` */
export const postEssayChapterStart = async (
  chapterId: number
): Promise<ChapterStartResponse> => {
  const res = await api.post<BaseResponse<ChapterStartResponse>>(
    `/app/essay-learning/chapters/${chapterId}/start`
  );
  return res.data.result;
};

/** 챕터 제출. `POST /app/essay-learning/chapters/{id}/submit` */
export const postEssayChapterSubmit = async (
  chapterId: number
): Promise<ChapterSubmitResponse> => {
  const res = await api.post<BaseResponse<ChapterSubmitResponse>>(
    `/app/essay-learning/chapters/${chapterId}/submit`
  );
  return res.data.result;
};

export default useGetEssayChapter;
